import { latestBrandReleases } from '../../../shared/brand-latest/latestReleases';

export const featuredBooks = [
  {
    isbn: '978-957-43-8901-0',
    title: '人工智慧導論',
    subtitle: '從基礎理論到深度學習',
    author: '李開復、王詠剛',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20book%20cover%20design%20for%20artificial%20intelligence%20textbook%20with%20geometric%20neural%20network%20patterns%20in%20muted%20purple%20and%20gold%20on%20cream%20white%20background%2C%20clean%20academic%20aesthetic%2C%20scholarly%20publishing%20style&width=800&height=1100&seq=book-ai-intro&orientation=portrait',
    publishDate: '2025-09-15',
    price: 680,
    category: '資訊科技',
    topicTags: ['人工智慧', '深度學習', '機器學習'],
    description: '本書系統性地介紹人工智慧的核心概念與技術演進，從基礎的搜尋演算法、知識表示，到現代的深度學習與強化學習，提供讀者完整的 AI 知識架構。',
  },
  {
    isbn: '978-957-43-8902-7',
    title: '科普物理學',
    subtitle: '用圖解理解宇宙運行的規則',
    author: '趙凱華',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20for%20popular%20science%20physics%20book%20with%20minimalist%20atom%20and%20wave%20illustrations%20in%20deep%20blue%20and%20cream%20white%2C%20clean%20scholarly%20aesthetic%2C%20modern%20academic%20publishing&width=800&height=1100&seq=book-physics&orientation=portrait',
    publishDate: '2025-07-20',
    price: 580,
    category: '科普知識',
    topicTags: ['物理學', '科普', '科學思維'],
    description: '以淺顯易懂的圖解方式，帶領讀者探索物理學的核心概念，從牛頓力學到量子力學，建立對宇宙運行規則的基礎理解。',
  },
  {
    isbn: '978-957-43-8903-4',
    title: '生命科學基礎',
    subtitle: '從分子到生態系統',
    author: '陳宜民',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20for%20life%20science%20textbook%20with%20minimalist%20DNA%20helix%20and%20cell%20illustrations%20in%20muted%20sage%20green%20and%20cream%20white%2C%20clean%20scholarly%20aesthetic%2C%20modern%20academic%20publishing&width=800&height=1100&seq=book-biology&orientation=portrait',
    publishDate: '2025-06-10',
    price: 650,
    category: '生物醫學',
    topicTags: ['生命科學', '分子生物學', '生態學'],
    description: '從分子層次到生態系統，本書完整涵蓋生命科學的核心知識領域，適合想建立生物學基礎架構的讀者。',
  },
  {
    isbn: '978-957-43-8904-1',
    title: '程式設計的藝術',
    subtitle: '從演算法到軟體架構',
    author: '高德納',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20book%20cover%20design%20for%20computer%20programming%20book%20with%20elegant%20code%20patterns%20and%20geometric%20shapes%20in%20slate%20gray%20and%20cream%20white%2C%20clean%20academic%20aesthetic%2C%20scholarly%20publishing&width=800&height=1100&seq=book-programming&orientation=portrait',
    publishDate: '2025-08-05',
    price: 720,
    category: '資訊科技',
    topicTags: ['程式設計', '演算法', '軟體架構'],
    description: '經典程式設計著作的繁體中文版，深入探討演算法設計、資料結構與軟體架構的核心原則。',
  },
  {
    isbn: '978-957-43-8905-8',
    title: '經濟學的思維方式',
    subtitle: '理解市場、決策與社會',
    author: '保羅·海恩',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20for%20economics%20textbook%20with%20minimalist%20supply%20demand%20curve%20illustration%20in%20warm%20brown%20and%20cream%20white%2C%20clean%20scholarly%20aesthetic%2C%20modern%20academic%20publishing&width=800&height=1100&seq=book-economics&orientation=portrait',
    publishDate: '2025-05-18',
    price: 620,
    category: '經管人文',
    topicTags: ['經濟學', '市場', '決策思維'],
    description: '以經濟學的思維方式為核心，幫助讀者理解市場運作、決策邏輯與社會現象背後的經濟學原理。',
  },
  {
    isbn: '978-957-43-8906-5',
    title: '圖解量子力學',
    subtitle: '彩色視覺化理解量子世界',
    author: '布萊恩·考克斯',
    originalPublisher: '北京清華大學出版社',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20book%20cover%20design%20for%20illustrated%20quantum%20mechanics%20book%20with%20colorful%20wave%20particle%20duality%20visualizations%20in%20multi%20color%20spectrum%20on%20cream%20white%20background%2C%20modern%20visual%20knowledge%20style&width=800&height=1100&seq=book-quantum&orientation=portrait',
    publishDate: '2025-10-01',
    price: 880,
    category: '彩色知識書',
    topicTags: ['量子力學', '圖解', '視覺化知識'],
    description: '以全彩圖解方式呈現量子力學的核心概念，將抽象的量子現象轉化為直觀的視覺理解，適合想以圖像輔助學習的讀者。',
  },
];

export const newReleases = [
  ...latestBrandReleases
    .filter((book) => book.brandSlug === 'qinghua-wenquan')
    .map((book) => ({
      isbn: book.isbn,
      title: book.title,
      author: book.author,
      category: book.category,
      coverImage: book.coverImage,
      publishDate: book.publishDate,
    })),
  {
    isbn: '9786267165478',
    title: 'AIGC 工業設計 實戰課',
    author: '宋一煊，林宏秋，劉少清',
    category: '資訊科技',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/ff9f7c85-f0f4-4881-9052-afeb8037b4cd_compressed_9786267165478.webp',
    publishDate: '2026-07-20',
  },
  {
    isbn: '9786267165430',
    title: '色彩的物競天擇，生命沒那麼理所當然',
    author: '史鈞',
    category: '科普知識',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/eeb3e5cf-f005-4eae-ba02-8c54d35cc4ed_compressed_9786267165430_3D_72dpi.webp',
    publishDate: '2026-07-20',
  },
  {
    isbn: '9786267165416',
    title: '冷血動物形貌史，魚類、兩棲與爬行類的演化變形記',
    author: '塞繆爾·希爾德布蘭 等',
    category: '科普知識',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/2f1cc38d-695d-4b82-93ad-2cb90652f721_compressed_9786267165416_3D_72dpi.webp',
    publishDate: '2026-07-20',
  },
  {
    isbn: '9786267165492',
    title: 'AIGC 互動設計實戰課',
    author: '吳應達，趙子軒，劉少清',
    category: '資訊科技',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/8050bac7-e427-4c45-a7bd-13607de39c7a_compressed_9786267165492.webp',
    publishDate: '2026-07-20',
  },
  {
    isbn: '9786267165515',
    title: '書途萬里，中華出版發展史',
    author: '鄭士德，鄭北星',
    category: '經管人文',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/9ce66157-fc1d-4a82-aaf7-166374a4156e_compressed_9786267165515_3D_72dpi.webp',
    publishDate: '2026-07-20',
  },
  {
    isbn: '9786267165447',
    title: '紅樓眾生相，被忽略的「小人物」敘事',
    author: '梁歸智',
    category: '經管人文',
    coverImage: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/830be9bc-c03e-49e4-abd8-a02c8dd6bd57_compressed_9786267165447.webp',
    publishDate: '2026-07-20',
  },
];
